module.exports = __webpack_public_path__ + "static/ART_Logo-usage_incorrect4-623d07554dfd2a716b95d8b97319b686.svg";